import { ApplicationWithCmsState } from '../../store/types';

export const navigationsRequestStateSelector = (
  state: ApplicationWithCmsState,
) => state.cms.prismicNavigations.request;

export const navigationsSelector = (state: ApplicationWithCmsState) =>
  state.cms.prismicNavigations.navigations;
